import { installBanners } from '@/app/common/biff/biffLoader.ts';

/**
 * The bottom ad block (AdsFooter.tsx): the GPT leaderboard and the AdSense for Search block. Kept apart so that
 * the cux_4119 variant (MPH-1274), which drops the block from the DP Evo page, skips exactly these ids.
 */
export const HOTEL_DETAIL_BOTTOM_POSITIONS = {
  GPT: ['div-gpt-ad-bottom3'],
  AFS: ['afs-details-bottom'],
};

/**
 * Slot ids agreed with the Media team; the containers live in adSlots.tsx and AdsFooter.tsx. The rooms ad
 * (RoomsAd.tsx) is not listed here: it installs itself once the rooms are on the page.
 */
export const HOTEL_DETAIL_POSITIONS = {
  GPT: ['div-gpt-ad-external_right2', 'div-gpt-ad-external_right3', ...HOTEL_DETAIL_BOTTOM_POSITIONS.GPT],
  AFS: [...HOTEL_DETAIL_BOTTOM_POSITIONS.AFS],
};

const AFS_OPTIONS = { number: 3 };

type InstallHotelDetailBannersOptions = {
  /** False when the page renders no bottom ad block, so biff is not asked for slots with nowhere to show. */
  withBottomAds?: boolean;
};

export const installHotelDetailBanners = ({ withBottomAds = true }: InstallHotelDetailBannersOptions = {}): void => {
  const gptIds = withBottomAds
    ? HOTEL_DETAIL_POSITIONS.GPT
    : HOTEL_DETAIL_POSITIONS.GPT.filter((id) => !HOTEL_DETAIL_BOTTOM_POSITIONS.GPT.includes(id));
  installBanners({ elements: gptIds, provider: 'googleDFP' });
  // Installing an AFS id with no container still asks AdSense for a block, so it is skipped with the block.
  if (withBottomAds) {
    installBanners({ elements: HOTEL_DETAIL_POSITIONS.AFS, provider: 'googleAFS', options: AFS_OPTIONS });
  }
};
